import { Clipboard } from '@angular/cdk/clipboard';
import {
	Directive,
	ElementRef,
	HostListener,
	Renderer2,
	Input,
	OnDestroy,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Directive({
	selector: '[appHoverCopy]',
})
export class CopyOnHoverDirective implements OnDestroy {
	@Input('appHoverCopy') public copyText?: string;
	private iconElement?: HTMLElement;
	private originalText = '';
	private readonly elementClickListener?: () => void;

	public constructor(
		private readonly el: ElementRef,
		private readonly renderer: Renderer2,
		private readonly clipboard: Clipboard,
		private readonly snackBar: MatSnackBar
	) {
		this.copyText = this.el.nativeElement.innerText;
		this.elementClickListener = this.renderer.listen(
			this.el.nativeElement,
			'click',
			() => this.copyToClipboard()
		);
	}

	@HostListener('mouseenter')
	public onMouseEnter(): void {
		this.originalText = this.el.nativeElement.innerText;
		if (!this.iconElement) {
			this.iconElement = this.renderer.createElement('span');
			this.renderer.addClass(this.iconElement, 'copy-icon');
			this.renderer.setProperty(this.iconElement, 'innerHTML', '&#x2398;'); // Copy icon (can be replaced)
			this.renderer.setStyle(this.iconElement, 'position', 'fixed');
			this.renderer.setStyle(this.iconElement, 'cursor', 'pointer');
			this.renderer.setStyle(this.iconElement, 'font-size', '16px');
			this.renderer.setStyle(this.iconElement, 'margin-left', '0.25rem');
			this.renderer.setStyle(this.iconElement, 'color', '#000000');
			this.renderer.setStyle(this.iconElement, 'z-index', '1000');

			this.renderer.setStyle(
				this.el.nativeElement,
				'text-decoration',
				'underline'
			);
			this.renderer.setStyle(this.el.nativeElement, 'cursor', 'copy');
			this.renderer.appendChild(this.el.nativeElement, this.iconElement);
		}
	}

	@HostListener('mouseleave')
	public onMouseLeave(): void {
		if (this.iconElement) {
			this.renderer.setStyle(this.el.nativeElement, 'text-decoration', 'none');
			this.renderer.removeChild(this.el.nativeElement, this.iconElement);
			this.iconElement = undefined;
		}
	}

	private copyToClipboard(): void {
		let textToCopy = this.originalText.trim();
		if (this.copyText?.trim()) {
			textToCopy = this.copyText?.trim();
		}
		if (this.clipboard.copy(textToCopy)) {
			this.snackBar.open($localize`:i18n=@@general.copied:`, '', {
				duration: 2000,
			});
		}
	}

	public ngOnDestroy(): void {
		if (this.elementClickListener) {
			this.elementClickListener();
		}
	}
}
